import { render, staticRenderFns } from "./comment-dialog.vue?vue&type=template&id=72bd9ade&scoped=true&"
import script from "./comment-dialog.vue?vue&type=script&lang=js&"
export * from "./comment-dialog.vue?vue&type=script&lang=js&"
import style0 from "./comment-dialog.vue?vue&type=style&index=0&id=72bd9ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd9ade",
  null
  
)

export default component.exports